import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { fetchLatestTerms, TermsResponse } from "services/termsService";
import { CountryCodeType } from "utils/constants";
import "./termsPage.scss";

interface TermsPageProps {
  countryCode: CountryCodeType;
}

const TermsPage: React.FC<TermsPageProps> = ({ countryCode }) => {
  const [termsData, setTermsData] = useState<TermsResponse | null>(null);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);
  const location = useLocation();

  useEffect(() => {
    const loadTerms = async () => {
      try {
        setLoading(true);
        const searchParams = new URLSearchParams(location.search);
        const appVersion = searchParams.get("appVersion") || "2.5.0";
        
        const data = await fetchLatestTerms(countryCode, appVersion);
        setTermsData(data);
        setError(null);
      } catch (err) {
        setError("Error al cargar los términos y condiciones");
      } finally {
        setLoading(false);
      }
    };

    loadTerms();
  }, [countryCode, location.search]);

  return (
    <div className="terms-page">
      {loading && (
        <div className="loading-container">
          <div className="spinner"></div>
          <p>Cargando términos y condiciones...</p>
        </div>
      )}

      {error && (
        <div className="error-container">
          <p>{error}</p>
        </div>
      )}

      {!loading && !error && termsData && (
        <div className="document-container">
          <iframe
            src={`https://docs.google.com/viewer?url=${encodeURIComponent(termsData.url)}&embedded=true`}
            title="Términos y Condiciones"
            className="document-iframe"
          />
        </div>
      )}
    </div>
  );
};

export default TermsPage;

